document.addEventListener('mimeeq-add-to-cart', (e) => {
    console.log(e.detail.shortCode);
    console.log(e.detail.qty);
    document.dispatchEvent(new Event('mimeeq-show-basket-loader'));
    $.ajax({
      headers: { 'X-API-KEY' : 'xyAFHNHBCQgGzuj8y0rX6ez4NUsgTrlsvR6' },
      url : 'https://mimeeqapi.com/get-product-info',
      type : 'GET',
      data : {
          'shortCode' : e.detail.shortCode,
          'quantity' : e.detail.qty
      },
      success : function(data) {
              console.log(data);
              let formData = {items : [] };
              for (let i = 0; i < data.components.length; i++) {
                  shopifyID = getProduct(data.components[i].SKU).id;
                  formData.items[i] = { 'id': shopifyID, 'quantity': data.components[i].quantity };
              };
              console.log(formData);
              fetch(window.Shopify.routes.root + 'cart/add.js', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(formData)
              })
              .then(response => {
                  return response.json().then((responseJson) => { 
                      if (response.ok) {
                          window.location.href = "https://modloft.com/cart"
                      } else {

                          document.dispatchEvent(new Event('mimeeq-hide-basket-loader'));
                          error_msg = '<div id="composer-error" class="form__banner banner banner--error" style="display: none;"><span class="banner__ribbon"><svg focusable="false" width="18" height="26" class="icon icon--form-error" viewbox="0 0 18 26"> <circle cx="9" cy="13" r="8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"></circle> <path d="M8.993 15.262a.972.972 0 00-.979.968c0 .539.44.99.98.99a.99.99 0 00.978-.99.972.972 0 00-.979-.968zm-.78-.649h1.561V8.706H8.212v5.907z" fill="currentColor"></path> </svg></span><p id="composer-message" class="banner__content">'+responseJson.description+'</p></div>';
                          console.log('Inv Error');
                          console.log(responseJson.description);
                          $('#mmq-modal-summary #mmq-content-wrapper').append(error_msg);
                          $('#composer-error').show();
                          //$('#mmq-modal-summary #mmq-content-wrapper button.kRyaCx').html('Add to cart');

                      }
                  });

              })
              .catch((error) => {
                  console.log('Error adding to cart');
                  console.error(error);
                  console.error('Error:', error);
                  return error;
              }); 
          }
    });

  });

  document.addEventListener('mimeeq-modular-closed', (e) => {
      if ( window.history.length > 4 ) {
          window.history.go(-3);
      } else {
          window.location.href = "https://modloft.com/pages/modular-sofa-collections";
      }
  });

  function getProduct(sku) {

    var products = [
{ "sku" : "MD821-OTTO-3288", "id" : "42742020440305" },
{ "sku" : "MD821-TP-3288", "id" : "42742019588337" },
{ "sku" : "MD821-1S-L-3286", "id" : "43576241914097" },
{ "sku" : "MD821-1S-L-3288", "id" : "43576241979633" },
{ "sku" : "MD821-1S-R-3286", "id" : "44200476475633" },
{ "sku" : "MD821-1S-R-3288", "id" : "43576242012401" },
{ "sku" : "MD821-1S-3286", "id" : "42742019227889" },
{ "sku" : "MD821-1S-3288", "id" : "42742019260657" },
{ "sku" : "MD821-1S-CRN-3286", "id" : "42742020342001" },
{ "sku" : "MD821-1S-CRN-3288", "id" : "42742020374769" },
{ "sku" : "MD828-2S-L-CRM", "id" : "43921748492529" },
{ "sku" : "MD828-96-CRM", "id" : "42742076571889" },
{ "sku" : "MD828-1S-CRM", "id" : "42742038397169" },
{ "sku" : "MD828-CH-L-CRM", "id" : "44383166791921" },
{ "sku" : "MD828-CH-R-CRM", "id" : "42742042362097" },
{ "sku" : "MD828-CRN-CRM", "id" : "42742043410673" },
{ "sku" : "MD828-END-R-CRM", "id" : "43982989820145" },
{ "sku" : "MD828-SET01-2PC-CRM", "id" : "42742047047921" },
{ "sku" : "MD822-1SL-3288", "id" : "44085872623857" },
{ "sku" : "MD822-1SR-3288", "id" : "42742071886065" },
{ "sku" : "MD822-1S-3288", "id" : "42742074474737" },
{ "sku" : "MD822-OTTO2-3285", "id" : "45140279296241" },
{ "sku" : "MD822-CHL-3288", "id" : "42742077948145" },
{ "sku" : "MD822-CHR-3288", "id" : "42742077980913" },
{ "sku" : "MD822-CRN-3288", "id" : "42742079946993" },
{ "sku" : "MD822-SUML-3288", "id" : "42742081290481" },
{ "sku" : "MD822-SUMR-3288", "id" : "42742081323249" },
{ "sku" : "MD822-OTTO-3288", "id" : "43983128658161" },
{ "sku" : "MD821-SET01-5PC-CHK", "id" : "45286292914417" },
{ "sku" : "MD821-SET01-5PC-GRS", "id" : "45286292881649" },
{ "sku" : "MD821-SET02A-5PC-CHK", "id" : "45286292717809" },
{ "sku" : "MD821-SET02B-5PC-CHK", "id" : "45286292685041" },
{ "sku" : "MD828-SET02B-2PC-CRM", "id" : "42742049341681" },
{ "sku" : "MD821-SET03-6PC-CHK", "id" : "45286291931377" },
{ "sku" : "MD821-SET05-2PC-CHK", "id" : "42742052978929" },
{ "sku" : "MD821-SET05-2PC-GRS", "id" : "44243402031345" },
{ "sku" : "MD821-SET06-3PC-CHK", "id" : "45247553863921" },
{ "sku" : "MD821-SET06-3PC-GRS", "id" : "45286290522353" },
{ "sku" : "MD821-SET07-4PC-CHK", "id" : "45245622747377" },
{ "sku" : "MD821-SET08-4PC-CHK", "id" : "45286290194673" },
{ "sku" : "MD821-SET08-4PC-GRS", "id" : "45286290161905" },
{ "sku" : "MD822-SET01-2PC-CHK", "id" : "42742082207985" },
{ "sku" : "MD822-SET02-3PC-CHK", "id" : "42742020800753" },
{ "sku" : "MD822-SET25A-3PC-CHK", "id" : "42742064939249" },
{ "sku" : "MD822-SET25B-3PC-CHK", "id" : "42742064972017" },
{ "sku" : "MD822-SET27-3PC-CHK", "id" : "42742069559537" },
{ "sku" : "MD822-SET30A-5PC-CHK", "id" : "42742071591153" },
{ "sku" : "MD822-SET30B-5PC-CHK", "id" : "42742071623921" },
{ "sku" : "MD822-SET05-4PC-CHK", "id" : "42742032924913" },
{ "sku" : "MD822-SET07A-3PC-CHK", "id" : "42742037610737" },
{ "sku" : "MD822-SET07B-3PC-CHK", "id" : "42742037643505" },
{ "sku" : "MD822-SET08A-2PC-CHK", "id" : "42742040920305" },
{ "sku" : "MD822-SET08B-2PC-CHK", "id" : "42742040887537" },
{ "sku" : "MD822-SET12-4PC-CHK", "id" : "42742046392561" }
];

  p = "N/A";

  $.each(products, function(i, obj) {
      if (sku == obj.sku) {
          p = obj;
      }
  });

  return p;

  }